import React from 'react';
import { TaskCommentsModalTemplate } from 'themes/application/dashboard/components';
import { observer } from 'mobx-react';
import { TaskCommentsModalStore } from 'application/dashboard/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new TaskCommentsModalStore(rootStore, componentProps), 'taskCommentsModalStore')
@observer
class TaskCommentsModal extends React.Component {
    render() {
        return <TaskCommentsModalTemplate {...this.props} />
    }
}

export default TaskCommentsModal;